module.exports = __webpack_public_path__ + "img/personel.575fa773.png";